import { render, staticRenderFns } from "./object-editor.vue?vue&type=template&id=563b5d2d&scoped=true&"
import script from "./object-editor.vue?vue&type=script&lang=js&"
export * from "./object-editor.vue?vue&type=script&lang=js&"
import style0 from "./object-editor.vue?vue&type=style&index=0&id=563b5d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b5d2d",
  null
  
)

export default component.exports